export default __webpack_public_path__ + "static/media/toggle-btn.fac2d329.svg";